import React from "react";
import { MdError } from "react-icons/md";

import { LoadFileError } from "../gen/ClientState";
import { PathRelFile } from "../gen/Path";
import styles from "./LoadFileErrorPanel.module.css";

export interface LoadFileErrorPanelProps {
  filePath: PathRelFile | null;
  data: LoadFileError;
}

function LoadFileErrorPanel(props: LoadFileErrorPanelProps): JSX.Element {
  return (
    <div className={styles.root}>
      <div className={styles.cont}>
        <div className={styles.title}>
          <MdError color="#c00" size="34px" style={{ verticalAlign: "bottom" }} />{" "}
          {props.data.title}
        </div>
        <div className={styles.heading}>Error loading file: {props.filePath}</div>
        <pre className={styles.message}>{props.data.message}</pre>
      </div>
    </div>
  );
}

export default LoadFileErrorPanel;
